import { styled } from 'styled-components';

import { Box, Typography } from '@mui/material';

export const MessageModalBox = styled(Box)`
  position: absolute;
  top: 45%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 400px;
  background-color: #fa4949;
  box-shadow: 24;
  border-radius: 8px;
  border: none;
  color: #ffffff;
  text-align: center;
  outline: none;
  padding: 16px;
  z-index: 1300;
`;

export const MessageContent = styled(Typography)`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const IconWrapper = styled.span`
  margin-right: 15px;
`;
